// Source for validEmailRegex: https://emailregex.com
const validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"!]+(\.[^<>()\[\]\\.,;:\s@"!]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export function emailIsValid(email) {
    return validEmailRegex.test(email.toLowerCase());
}
//# sourceMappingURL=email.js.map